import React from 'react';

import '@app/scss/components/pagination.scss';

interface Props {
	current: number;
	total: number;
	onChange?: (page) => void;
	pageSize?: number;
}

const Pagination: React.FC<Props> = ({
	current = 1,
	total,
	onChange,
	pageSize = 8,
}) => {
	const [count, setCount] = React.useState(Math.ceil((total || 0) / (pageSize || 1)));
	const [pageActive, setPageActive] = React.useState<number>(current);

	const handleChange = (e, page) => {
		e.preventDefault();
		if (page > 0 && page <= count) {
			onChange && onChange(page);
			setPageActive(page);
			window.scrollTo(0, 300);
		}
	};

	React.useEffect(() => {
		setPageActive(current);
		setCount(Math.ceil((total || 0) / (pageSize || 1)));
	}, [current, total]);

	return <div className="pagination">
		<div className="text-center">
			<a
				className={`pagination-button prev ${pageActive === 1 ? 'disabled' : ''}`}
				href=""
				onClick={(e) => handleChange(e, pageActive - 1)}
				aria-label="prev page"
			>
				<svg xmlns="http://www.w3.org/2000/svg" width="49" height="21" viewBox="0 0 49 21" fill="none">
					<path
						d="M47.3427 9.82578C33.9784 9.39122 20.674 9.57486 7.36967 9.75852C11.5776 7.89791 15.9562 6.18062 20.3049
						4.15421C22.2532 3.23516 21.1601 0.0457741 19.0412 0.821521C13.1661 3.26956 7.60239 5.69509 1.72737
						8.14313C0.823519 8.51975 0.431572 9.32628 0.662181 10.0878C0.0995987 10.751 -0.0917342 12.01 0.902079
						12.5607C4.59604 15.0951 8.11937 17.4862 11.6727 20.1865C13.5197 21.4537 15.4887 19.1324 13.923 17.5336C12.046
						15.9573 10.3397 14.5242 8.60339 12.7821C21.4258 12.4777 34.5895 12.4598 47.352 11.5371C48.7677 11.5904 48.4471
						9.90158 47.3427 9.82578Z"
						fill="currentColor"
					/>
				</svg>
			</a>
			{pageActive >= 3
				? <a className="pagination-button" onClick={(e) => handleChange(e, 1)} href="">1</a>
				: null
			}
			{pageActive >= 4
				? <button type="button" disabled className="pagination-button">...</button>
				: null
			}
			{Array.from({ length: 3 }).map((_, i) => count >= pageActive - 1 + i && pageActive - 1 + i !== 0
				&& (
					<a
						key={pageActive - 1 + i}
						className={`pagination-button ${i === 1 ? 'active' : ''}`}
						onClick={(e) => handleChange(e, pageActive - 1 + i)}
						href=""
					>
						{pageActive - 1 + i}
					</a>
				))
			}
			{pageActive <= count - 4
				? <button type="button" disabled className="pagination-button">...</button>
				: null
			}
			{pageActive <= count - 3
				? <a className="pagination-button" onClick={(e) => handleChange(e, count)} href="">{count}</a>
				: null
			}
			<a
				className={`pagination-button next ${pageActive === count ? 'disabled' : ''}`}
				href=""
				onClick={(e) => handleChange(e, pageActive + 1)}
				aria-label="next page"
			>
				<svg xmlns="http://www.w3.org/2000/svg" width="49" height="21" viewBox="0 0 49 21" fill="none">
					<path
						d="M0.955188 9.37266C14.3195 8.93809 27.6238 9.12174 40.9282 9.30539C36.7202 7.44479 32.3416 5.72749 27.993
						3.70108C26.0446 2.78204 27.1377 -0.407351 29.2567 0.368396C35.1317 2.81644 40.6955 5.24197 46.5705 7.69001C47.4743
						8.06663 47.8663 8.87316 47.6357 9.63468C48.1983 10.2979 48.3896 11.5569 47.3958 12.1076C43.7018 14.642 40.1785
						17.0331 36.6252 19.7334C34.7782 21.0006 32.8091 18.6793 34.3748 17.0805C36.2518 15.5041 37.9581 14.0711 39.6945
						12.329C26.872 12.0245 13.7083 12.0067 0.945893 11.084C-0.46986 11.1373 -0.149283 9.44845 0.955188 9.37266Z"
						fill="currentColor"
					/>
				</svg>
			</a>
		</div>
	</div>;
};

export default Pagination;
